<template>
  <div>
    <div v-if="form">
      <div>
        <p><b>Group</b></p>
        <input class="outlined" v-model="form.data.feed_designator.fields.group.value">
      </div>
      <div>
        <p><b>Designator</b></p>
        <input class="outlined" v-model="form.data.feed_designator.fields.designator.value">
      </div>
      <div>
        <p><b>Priority</b></p>
        <input class="outlined" v-model="form.data.feed_designator.fields.priority.value">
      </div>
      <div>
        <p><b>Minimum Permission</b></p>
        <input class="outlined" v-model="form.data.feed_designator.fields.minimum_permission.value">
      </div>
      <div>
        <p><b>Maximum Permission</b></p>
        <input class="outlined" v-model="form.data.feed_designator.fields.maximum_permission.value">
      </div>
      <div>
        <p><b>Time Estimation</b></p>
        <input class="outlined" v-model="form.data.feed_designator.fields.time_estimation.value">
      </div>
      <div>
        <p><b>Before Answer Time Estimation</b></p>
        <input class="outlined" v-model="form.data.feed_designator.fields.before_answer_time_estimation.value">
      </div>
      <div>
        <p><b>Information</b></p>
        <input class="outlined" v-model="form.data.feed_designator.fields.information.value">
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'admin-feed-designators-form',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      form: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        return
      }
      this.$network_utils.getFeedDesignator({ id: this.payload.data.id }).then(response => {
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        feed_designator: {
          fields: {
            group: {
              value: form_data.group,
              has_error: false,
              validations: []
            },
            designator: {
              value: form_data.designator,
              has_error: false,
              validations: []
            },
            minimum_permission: {
              value: form_data.minimum_permission,
              has_error: false,
              validations: []
            },
            maximum_permission: {
              value: form_data.maximum_permission,
              has_error: false,
              validations: []
            },
            priority: {
              value: form_data.priority,
              has_error: false,
              validations: []
            },
            time_estimation: {
              value: form_data.time_estimation,
              has_error: false,
              validations: []
            },
            before_answer_time_estimation: {
              value: form_data.before_answer_time_estimation,
              has_error: false,
              validations: []
            },
            information: {
              value: form_data.information,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/feed_designators/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
